<template>
    <div class="container">
        <div class="whiteBgSec_1 welcomeSec">
            <div class="container" style="max-width: 580px !important">
                <h2>Unlock the full potential of <span class="magicAiStyle">Magic AI</span>  today!</h2>
                <p>Sign up today and claim <strong><i>20 FREE Tokens</i></strong> to explore the limitless possibilities of Magic AI. Your journey to innovation begins now!</p> 
                <router-link class="gradientBtn_1" to="/design-ai/login">Start Now</router-link >
            </div>
            <div class="row pt-5 pb-5">
                <div class="col-md-6 py-3 py-md-0">
                    <div class="widgetSec">
                            <a href="javascript:void(0);">
                                <img src="assets/images/original.png" alt="">
                                <h4>Original</h4>
                            </a>
                    </div>
                </div>
                <div class="col-md-6 py-3 py-md-0">
                    <div class="widgetSec">
                        <a href="javascript:void(0);">
                            <img src="assets/images/ai_redesigned.png" alt="">
                            <h4>AI Redesigned</h4>
                        </a>
                    </div>
                </div>
            </div>
            <div class="container" style="max-width: 580px !important">
                <div class="row py-5">
                    <div class="col-12">
                        <h3 class="text-center">Turn your ideas into reality in <br> less than 60 seconds!</h3>
                        <p class="pt-4">Bring your vision to life with stunning designs in seconds, easily get an estimate for the job and purchase every material you love directly from {{ showroomId? showroomId.showroom_name:'Wevisu' }}!</p>
 
                        
                    </div>
                </div>
            </div>
            <div class="container">
                <video class="welcomePageVdo" autoplay controls muted>
                    <source src="assets/images/welcomePageVdo.mp4" type="video/mp4">
                    <source src="assets/images/welcomePageVdo.ogv" type="video/ogv">
                    Your browser does not support the video tag.
                </video> 
            </div>
            
            
        </div>
    </div>
</template> 
<script>

import {mapActions,mapGetters} from 'vuex'
import axios  from "axios";  



export default { 
 

 components:{
 },
    data(){
        return{            
        }
    },
    watch: { 
 
         },
    computed: { 
        ...mapGetters("Aiauth", ["Aiuser","CoinData"]), 
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]), 
    },
    methods:{ 
        

    },

    mounted() { 
        
    },
     


}
</script>
